import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams, ISimpleFilter } from 'ag-grid-community';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { AppPartnersService } from 'src/app/shared/services/app-partners.service';

export interface CustomParams {
  suppressFilterButton: boolean;
  filter: string;
  onSearchEvent: (event: any) => void;
}

@Component({
  selector: 'app-lrc-wallets-renderer',
  templateUrl: './lrc-wallets-renderer.component.html',
  styleUrls: ['./lrc-wallets-renderer.component.scss'],
})
export class LrcWalletsRendererComponent
  extends ListingBaseComponent
  implements IFloatingFilterAngularComp
{
  @Output() onFilterSearchText: EventEmitter<any> = new EventEmitter<any>();

  filterSearchText = new Subject<any>();
  filterText: string | null = null;

  params!: IFloatingFilterParams<ISimpleFilter> & CustomParams;
  IFloatingParams: IFloatingFilterParams | any;

  filterOptions: any[] = [];
  currentValue: any;
  value: any;

  constructor(injector: Injector, private partnerService: AppPartnersService) {
    super(injector);
  }

  agInit(params: IFloatingFilterParams<ISimpleFilter> & CustomParams) {
    this.partnerService.getAllWalletTypes().subscribe((resp) => {
      this.filterOptions = resp.results;
    });

    this.filterText = null;
    this.params = params;

    this.filterSearchText
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe({
        next: (event: any) => {
          this.params?.onSearchEvent({
            value: event?.target?.value,
            filter: params?.filter,
          });
        },
      });
  }

  onParentModelChanged(parentModel: any) {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
      this.filterOptions = [];
    } else {
      this.currentValue = parentModel.filter;
    }
  }
}
